<template>
  <div>
    <h1>{{ $t('assessments_available_header') }}</h1>
    <hr />

    <section v-if="completedAllActivities">
      <p>
        {{ $t('assessments_available_empty_body') }}
      </p>
    </section>

    <section v-else>
      <p>
        {{ $t('assessments_available_body') }}
      </p>

      <Row>
        <Column v-for="a in activities" :key="a.sub_type" class="col-4">
          <Card
            outlined
            :to="`/pre-exam/${a.name}`"
            :disabled="a.hasCameraError || a.isProcessing"
          >
            <CardBody center>
              <img :src="a.icon_image" width="80" />
              <h4>{{ a.title }}</h4>
              <template v-if="a.hasCameraError">
                <h5>
                  <Icon class="mdi-alert" />
                  {{ $t('assessment_unavailable_camera_header') }}
                </h5>
                <hr />
                <p>
                  {{ $t('assessment_unavailable_camera_body') }}
                </p>
              </template>
              <template v-else-if="a.isTodo">
                <h5><Icon class="mdi-clock" /> {{ a.duration }}</h5>
                <hr />
                <p>
                  <b>{{ $t('domain_measured') }}</b>
                  <br />{{ a.domains_measured }}
                </p>
              </template>
              <h5 v-else>{{ $t('assessment_processing') }}</h5>
            </CardBody>
            <template #overlay v-if="a.isTodo">
              <CardBody center>
                <p>
                  {{ $t('start_exam_button') }} <Icon class="mdi-arrow-right" />
                </p>
              </CardBody>
            </template>
          </Card>
        </Column>
      </Row>
    </section>
  </div>
</template>

<script>
import {
  Row,
  Col as Column,
  Card,
  CardBody,
  Icon
} from '@neurotrack/web-shared-components'
import { mapGetters } from 'vuex'

export default {
  components: {
    Row, Column, Card, CardBody, Icon
  },
  computed: {
    ...mapGetters('activities', ['flattenedActivities']),
    activities() {
      const acts = this.flattenedActivities({ completed: false })
      if (acts) {
        return acts
          /** Sort reverse chronologically */
          .sort((a, b) => {
            const left = a.priority
            const right = b.priority
            if (left !== right) {
              return left - right
            }
            if (a.title < b.title) {
              return -1
            }
            if (b.title > a.title) {
              return 1
            }
            return 0
          })
      }
      return []
    },
    completedAllActivities() {
      return this.hasActivities && this.activities.length === 0
    },
    hasActivities() {
      return !!this.activities
    }
  }
}
</script>
